import { useEffect } from "react";

import { useSearchParams } from "@/shared/navigation/useNavigation";
import { PHONE_FRAME_PARAM } from "./PageInPhoneFrame";

const PHONE_FRAME_TOP_PADDING = "50px";

export function PhoneFrameBodyPadding() {
  const searchParams = useSearchParams();
  const isInPhoneFrame = searchParams.has(PHONE_FRAME_PARAM);

  useEffect(() => {
    if (!isInPhoneFrame) return;

    document.body.style.paddingTop = PHONE_FRAME_TOP_PADDING;

    return () => {
      document.body.style.paddingTop = "";
    };
  }, [isInPhoneFrame]);

  return null;
}
